/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useUploadsContext } from '@sendible/frontendv2/src/models/uploads/uploadsContext';
import { subscribe, EVENTS } from '@sendible/event-manager';
import {
  useToastNotificationContext,
  Spinner,
} from '@sendible/design-system';
import { NotificationTypeEnum } from '@sendible/design-system/src/components/molecules/Toast';
import { composeMediaInteractions } from '@sendible/frontendv2/src/components/MediaSystem/composeMediaInteractions';
import {
  getPosterValidationMessages,
} from '@sendible/frontendv2/src/components/MediaSystem/components/MediaValidations/useGetValidationForMedia';
import { tabToFriendlyNameMapping } from '@sendible/frontendv2/src/models/medias/consts';
import { YT_PRIVACY_PUBLIC } from './constants';
import { Button as LegacyButton } from '../scss/legacy_design_system/js';
import Close from '../Icons/Close';
import Input from '../Common/Input/index';
import AutoSuggest from '../Common/Autosuggest';
import AlertMessage from '../Common/AlertMessage';
import Dropdown from '../Common/Dropdown/index';
import { dialog } from '../Common/Dialog';
import FramePicker from './FramePicker';
import HeaderSection from './components/HeaderSection';
import PrivacySection from './components/PrivacySection';
import classNames from '../utils/dom-utils';
import Loading from '../Icons/Loading';

import './scss/index.scss';

const characterCountMax = [
  {
    platform: 'youtube',
    name: 'YouTube',
    max: 100,
    errorType: 'error',
  },
  {
    platform: 'linkedin',
    name: 'LinkedIn',
    max: 150,
    errorType: 'warning',
  },
  {
    platform: 'facebook',
    name: 'Facebook',
    max: 255,
    errorType: 'warning',
  },
];

const optionsList = [
  'Autos & Vehicles',
  'Comedy',
  'Education',
  'Entertainment',
  'Film & Animation',
  'Gaming',
  'Howto & Style',
  'Music',
  'News & Politics',
  'People & Blogs',
  'Pets & Animals',
  'Science & Technology',
  'Sports',
  'Travel & Events',
  'None',
];

const translate = (key) => (window.translate ? window.translate(key) : key);

export class VideoThumbnail extends Component {
  constructor(props) {
    super(props);
    const services = props.services || [];
    const title = props.title || '';
    const frameInMiliseconds = props.frameInMiliseconds || 0;

    const profilesCount = [];
    let maxCharacters = 9999;
    let hasError = false;
    let errorType = 'none';
    let errorMessages = [];

    if (services.length > 0) {
      const uniqueServices = [...new Set(services)];
      uniqueServices.map((service) => {
        const profileCharacterMax = characterCountMax.filter(
          (e) => e.platform == service,
        );

        if (profileCharacterMax.length > 0) {
          if (profileCharacterMax[0].max < maxCharacters) {
            maxCharacters = profileCharacterMax[0].max;
          }
          profilesCount.push(profileCharacterMax[0]);
        }

        return profilesCount;
      });
    }

    if (
      title
            && title.length > 0
            && profilesCount.length > 0
    ) {
      errorMessages = this.showAlertMessage(
        title.length,
        profilesCount,
      );
      if (errorMessages.length > 0) {
        hasError = true;
        errorType = 'warning';

        if (
          errorMessages.filter((x) => x.errorType == 'error').length > 0
        ) {
          errorType = 'error';
        }
      }
    }

    this.state = {
      darkTheme: true,
      frameInSeconds: frameInMiliseconds / 1000,
      customThumbnailUrl: '',
      isThumbnailUploading: false,
      title,
      category: props.category,
      membersToNotify: props.membersToNotify || [],
      youtubePrivacyStatus: props.youtubePrivacyStatus || YT_PRIVACY_PUBLIC,
      availableMembers: [],
      showMembers: [],
      profilesCount,
      errorMessages,
      hasError,
      errorType,
      aspectRatio: 0,
      isSeeking: false,
      isLoading: false,
    };
    this.firstInputRef = React.createRef();
    this.thumbnailUploadInputRef = React.createRef();
    this.unsubscribeCustomThumbnailReady = null;
    this.unsubscribeCustomThumbnailFail = null;
    this.thumbnailUploadFileId = null;
    this.uploadingThumbnailMediaId = null;
  }

  componentDidMount() {
    if (this.firstInputRef.current) {
      setTimeout(() => this.firstInputRef.current.focus(), 500);
    }
    this.unsubscribeCustomThumbnailReady = subscribe(EVENTS.UPLOAD_READY, (readyMedia) => {
      if (readyMedia.id !== this.uploadingThumbnailMediaId) {
        return;
      }
      const posterErrors = this.getPosterErrors(readyMedia);
      if (posterErrors.length > 0) {
        composeMediaInteractions.deleteOrphanTwMedia(readyMedia.id);
        this.setState({
          customThumbnailUrl: '',
          isThumbnailUploading: false,
        });
        posterErrors.forEach((error) => {
          if (this.props.showToastNotification) {
            this.props.showToastNotification({
              notificationText: error,
              type: NotificationTypeEnum.Error,
              showCloseButton: true,
            });
          }
        });
      } else {
        if (this.state.updatedMediaId) {
          composeMediaInteractions.deleteOrphanTwMedia(this.state.updatedMediaId);
        }
        this.setState({
          updatedMediaId: readyMedia.id,
          customThumbnailUrl: readyMedia.posterUrl,
          frameInSeconds: 0,
          isThumbnailUploading: false,
        });
      }
    });
    this.unsubscribeCustomThumbnailFail = subscribe(EVENTS.UPLOAD_FAILED, (failedMedia) => {
      if (failedMedia.fileId !== this.thumbnailUploadFileId) {
        return;
      }

      this.setState({ isThumbnailUploading: false });
      if (this.props.showToastNotification) {
        this.props.showToastNotification({
          notificationText: failedMedia.error,
          type: NotificationTypeEnum.Error,
          showCloseButton: true,
        });
      }
    });
  }

  handleInputChange(textItem) {
    const { profilesCount } = this.state;
    const currentTextLength = textItem.innerText.length;
    let hasError = false;
    let errorMessages = [];
    let errorType = 'none';

    if (textItem.id === 'text-counter') {
      errorMessages = this.showAlertMessage(
        currentTextLength,
        profilesCount,
      );
      if (errorMessages.length > 0) {
        hasError = true;
        errorType = 'warning';

        if (
          errorMessages.filter((x) => x.errorType == 'error').length > 0
        ) {
          errorType = 'error';
        }
      }
    }

    this.setState({
      title: textItem.innerText,
      errorType,
      hasError,
      errorMessages,
    });
  }

  handleOnChange(value) {
     
    let updateList = [...this.state.availableMembers];

    value.forEach((member) => {
      updateList = updateList.filter((el) => el != member);
    });

    this.setState({ membersToNotify: value, showMembers: updateList });
  }

  async handleThumbnailFileChange(event) {
    const { files } = event.target;

    if (!files || !files.length) {
      return;
    }

    const selectedFile = files[0];
    const fileInput = event.target;
    fileInput.value = '';

    this.setState({ isThumbnailUploading: true });

    this.uploadAndCreateThumbnailMedia(selectedFile);
  }

  handleRemoveCustomThumbnail() {
    const frameInSeconds = 0.1;

    this.setState({
      customThumbnailUrl: '',
    });

    this.handleSliderChanged(frameInSeconds);
  }

  handleSliderChanged(vidPosition) {
    if (this.displayVideoElement) {
      this.displayVideoElement.currentTime = vidPosition;
    }

    this.setState({
      frameInSeconds: vidPosition,
      isSeeking: true,
    });
  }

  getPosterErrors(media) {
    if (this.props.isOriginalTab || !this.props.t) {
      return [];
    }

    const postType = this.props.postType || 'post';
    const uniqueServices = Array.from(new Set(this.props.services || []));

    return uniqueServices.reduce((acc, service) => {
      const posterValidations = getPosterValidationMessages(media, service, postType, this.props.t);
      const serviceName = tabToFriendlyNameMapping[service] ?? (service.charAt(0).toUpperCase() + service.slice(1));
      posterValidations.forEach((validation) => acc.push(`${serviceName}: ${validation.message}`));
      return acc;
    }, []);
  }

  categoryHandleChange(value) {
    this.setState({ category: value });
  }

  youtubePrivacyStatusHandleChange(value) {
    this.setState({ youtubePrivacyStatus: value });
  }

  showAlertMessage(currentTextLength, profilesCount) {
    const errorMessages = [];

    profilesCount.forEach((x, index) => {
      const profile = profilesCount[index];
      if (
        currentTextLength > profile.max
                && profile.errorType == 'error'
      ) {
        errorMessages.push({
          errorType: 'error',
          errorMessage: `The title is too long for ${profile.name}. Please enter a maximum of ${profile.max} characters.`,
        });
      } else if (
        currentTextLength > profile.max
                && profile.errorType == 'warning'
      ) {
        errorMessages.push({
          errorType: 'warning',
          errorMessage: `Please enter a maximum of ${profile.max} characters to prevent your text from being truncated on ${profile.name}.`,
        });
      }
    });

    return errorMessages;
  }

  overlayClick(event) {
    if (event.target && event.target.id == 'overlay') {
      this.closeClick(event);
    }
  }

  closeClick() {
    let mode = 'lightmode';
    const frameInSecondsProp = (this.props.frameInMiliseconds || 0) / 1000;
    if (this.state.darkTheme) {
      mode = 'darkmode';
    }

    const {
      frameInSeconds, title, category, membersToNotify,
    } = this.state;

    if (
      frameInSeconds != frameInSecondsProp
            || title != this.props.title
            || category != (this.props.category || 'None')
            || membersToNotify != (this.props.membersToNotify || [])
    ) {
      dialog({
        title: 'Discard all changes?',
        message: 'Any changes you made will not be saved.',
        primaryLabel: 'Discard',
        secondaryLabel: 'Cancel',
        primaryClick: () => this.close(),
        secondaryClick: () => null,
        mode,
      });
    } else {
      this.close();
    }
  }

  close() {
    if (this.state.updatedMediaId) {
      composeMediaInteractions.deleteOrphanTwMedia(this.state.updatedMediaId);
    }
    if (typeof this.unsubscribeCustomThumbnailReady === 'function') {
      this.unsubscribeCustomThumbnailReady();
      this.unsubscribeCustomThumbnailReady = null;
    }

    if (typeof this.unsubscribeCustomThumbnailFail === 'function') {
      this.unsubscribeCustomThumbnailFail();
      this.unsubscribeCustomThumbnailFail = null;
    }
    if (document.pictureInPictureElement) {
      document
        .exitPictureInPicture()
        .then(() => this.props.closeModal())
        .catch(() => this.props.closeModal());
    } else {
      this.props.closeModal();
    }
  }

  submit() {
    if (this.state.isThumbnailUploading) {
      return;
    }

    if (document.pictureInPictureElement) {
      document
        .exitPictureInPicture()
        .then(() => this.continueSubmit())
        .catch(() => this.continueSubmit());
    } else {
      this.continueSubmit();
    }
  }

  continueSubmit() {
    const {
      frameInSeconds, title, category, membersToNotify, youtubePrivacyStatus,
    } = this.state;

    this.setState({ isLoading: true });

    this.props.saveClicked({
      frameInMiliseconds: Math.round(frameInSeconds * 1000),
      title,
      category,
      membersToNotify,
      youtubePrivacyStatus,
      updatedMediaId: this.state.updatedMediaId,
    }, () => {
      this.setState({ isLoading: false });
    });
  }

  isVisible(service) {
    const services = this.props.services || [];
    if (services.length > 0) {
      const hasService = services.filter((e) => e == service);

      return hasService.length > 0;
    }

    return true;
  }

  initVideoData() {
    const aspectRatio = this.displayVideoElement.videoHeight
            / this.displayVideoElement.videoWidth;

    this.displayVideoElement.currentTime = this.state.frameInSeconds;

    this.setState({ aspectRatio });
  }

  triggerThumbnailUpload() {
    if (this.thumbnailUploadInputRef.current) {
      this.thumbnailUploadInputRef.current.click();
    }
  }

  async uploadAndCreateThumbnailMedia(selectedFile) {
    const uploadThumbnail = this.props.uploadThumbnail || (() => Promise.resolve(null));
    const uploadedThumbnailId = await uploadThumbnail({
      file: selectedFile,
      onUploadStarted: () => {
        const fileId = Math.random().toString();

        this.thumbnailUploadFileId = fileId;

        return fileId;
      },
    });
    if (uploadedThumbnailId) {
      const updateThumbnailById = this.props.updateThumbnailById || (() => Promise.resolve(null));
      const mediaItem = await updateThumbnailById({
        id: Number(uploadedThumbnailId),
        originalMediaId: this.props.originalMediaId,
        fileId: this.thumbnailUploadFileId,
      });

      if (mediaItem) {
        this.uploadingThumbnailMediaId = mediaItem.id;
      }

      return { uploadedThumbnailId: Number(uploadedThumbnailId), mediaItem };
    }
  }

  renderErrorMessage() {
    const { errorMessages } = this.state;

    const messages = errorMessages.map((e, index) => (
      <AlertMessage
         
        key={index}
        message={errorMessages[index].errorMessage}
        isWarning={errorMessages[index].errorType == 'warning'}
      />
    ));

    return messages;
  }

  render() {
    const {
      errorType,
      hasError,
      darkTheme,
      profilesCount,
      title,
      category,
      youtubePrivacyStatus,
      membersToNotify,
      frameInSeconds,
      customThumbnailUrl,
      isThumbnailUploading,
      showMembers,
      aspectRatio,
      isSeeking,
      isLoading,
    } = this.state;

    const { src, videoSize, rotationFix } = this.props;

    const { isOriginalTab } = this.props;
    const hasYoutube = this.isVisible('youtube');
    const hasLinkedin = this.isVisible('linkedin');
    const hasFacebook = this.isVisible('facebook');
    const hasInstagram = this.isVisible('instagram');
    const hasTikTok = this.isVisible('tiktok');
    const isGroupTabWithOnlyTikTok = !isOriginalTab
      && hasTikTok
      && (this.props.services || []).every((service) => service === 'tiktok' || service === 'group');

    const shouldShowUploadThumbnailButton = window.js_featureTagsManager?.isFeatureTag('mediaSystem')
      && !isGroupTabWithOnlyTikTok;

    const themeMode = darkTheme
      ? 'text-inputs text-inputs--dark'
      : 'text-inputs';

    let mode = 'lightmode';

    if (darkTheme) {
      mode = 'darkmode';
    }

    let classAspect = 'landscape';

    if (aspectRatio === 1) {
      classAspect = 'square';
    } else if (aspectRatio > 1) {
      classAspect = 'portrait';
    }

    const baseMainVideoClass = 'video-thumbnail-modal__body-video';

    const rootMainVideoClass = classNames(
      baseMainVideoClass,
      `${baseMainVideoClass}--${classAspect}`,
    );

    const titleSupportPopoverContent = (
      <section>
        <p>
          {`${translate('supported_on')}:`}
          <br />
          Facebook, LinkedIn, YouTube
        </p>
      </section>
    );

    const detailsSupportPopoverContent = (
      <section>
        <p>
          {`${translate('supported_on')}:`}
          <br />
          YouTube
        </p>
      </section>
    );

    const thumbnailSupportPopoverContent = (
      <section>
        <p>
          {`${translate('supported_on')}:`}
          <br />
          <ul>
            <li>{`Facebook, Instagram, LinkedIn, TikTok (${translate('select_from_video')})`}</li>
            <li>{`Facebook, Instagram, LinkedIn, YouTube (${translate('upload_image')})`}</li>
          </ul>
          {`${translate('note')}:`}
          <br />
          {translate('thumbnail_selection_not_supported_for_stories_or_instagram_reminders')}
        </p>
      </section>
    );

    let thumbnailContent = (
      <FramePicker
        src={src}
        onSliderChanged={this.handleSliderChanged.bind(this)}
        videoPosition={frameInSeconds}
        rotationFix={rotationFix}
        videoSize={videoSize}
        aspectRatio={aspectRatio}
      />
    );

    if (isThumbnailUploading) {
      thumbnailContent = (
        <div className="thumbnail__upload-loading">
          <Spinner size="sm" />
        </div>
      );
    }

    if (!isThumbnailUploading && customThumbnailUrl) {
      thumbnailContent = (
        <div className="thumbnail__custom-preview">
          <img
            src={customThumbnailUrl}
            alt="Custom thumbnail"
          />
          <LegacyButton
            size="small"
            variant="hollow-reverse"
            onClick={() => this.handleRemoveCustomThumbnail()}
          >
            Remove
          </LegacyButton>
        </div>
      );
    }

    return (
      <div
        id="overlay"
        className="video-thumbnail-overlay"
        onClick={(e) => this.overlayClick(e)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            this.closeClick();
          }
        }}
        role="button"
        tabIndex={0}
      >
        <div className="video-thumbnail-modal">
          <div className="video-thumbnail-modal__header">
            <h2>Video settings</h2>
            <button
              type="button"
              data-testid="close-element"
              aria-label="close button"
              className="video-thumbnail-modal__header-button--xl video-thumbnail-modal__header-button-xl-bottom-label"
              onClick={() => this.closeClick(this)}
            >
              <Close
                fill="#ffffff"
                width="1.25em"
                className="video-thumbnail-modal__header-icon"
              />
            </button>
          </div>
          <div className="video-thumbnail-modal__body">
            <div className="video-thumbnail-modal__body-details">
              {(isOriginalTab
                                || hasFacebook
                                || hasLinkedin
                                || hasYoutube) && (
                                <div className={themeMode}>
                                  <HeaderSection
                                    title="Title"
                                    supportPopoverContent={titleSupportPopoverContent}
                                  />
                                  <Input
                                    name="text-counter"
                                    title=""
                                     
                                    onChange={this.handleInputChange.bind(this)}
                                    characterCount={profilesCount}
                                    errorType={errorType}
                                    placeholder="Enter a title for your video..."
                                    darkTheme={darkTheme}
                                    value={title}
                                    ref={this.firstInputRef}
                                    tabIndex={0}
                                  />
                                    {hasError && this.renderErrorMessage()}
                                </div>
              )}
              {(isOriginalTab || hasYoutube) && (
              <div className="extra-details">
                <HeaderSection
                  title="Details"
                  supportPopoverContent={detailsSupportPopoverContent}
                />
                <AutoSuggest
                  id="tagAutoSuggest"
                  label=""
                  description=""
                  footerText=""
                  placeholder="Add a tag..."
                  availableMembers={showMembers}
                  isLoading={false}
                  membersToNotify={membersToNotify}
                  max={10}
                   
                  onChange={this.handleOnChange.bind(this)}
                  mode={mode}
                />
                <div className="extra-details__dropdown">
                  <Dropdown
                    items={optionsList}
                    darkTheme={darkTheme}
                     
                    onChange={this.categoryHandleChange.bind(this)}
                    value={category}
                  />
                </div>
                <PrivacySection
                  privacyStatusValue={youtubePrivacyStatus}
                  onChange={this.youtubePrivacyStatusHandleChange.bind(this)}
                />
              </div>
              )}
              {(isOriginalTab || hasFacebook || hasInstagram || hasTikTok || hasYoutube || hasLinkedin) && (
              <div className="thumbnail-details">
                <HeaderSection
                  title="Thumbnail"
                  supportPopoverContent={thumbnailSupportPopoverContent}
                />
                <div className="thumbnail">
                  <input
                    id="thumbnail-upload-file"
                    data-testid="thumbnail-upload-file-input"
                    ref={this.thumbnailUploadInputRef}
                    type="file"
                    accept="image/jpeg,image/png,image/gif,image/webp,image/bmp"
                    onChange={this.handleThumbnailFileChange.bind(this)}
                    style={{ display: 'none' }}
                  />
                  <div className="thumbnail__upload-option">
                    <p>
                      Select a thumbnail for the video by moving the slider below
                      {!shouldShowUploadThumbnailButton && '.'}
                    </p>
                    {shouldShowUploadThumbnailButton
                      && (
                      <>
                        <span>or</span>
                        <LegacyButton
                          size="small"
                          variant="hollow-reverse"
                          onClick={() => this.triggerThumbnailUpload()}
                        >
                          Upload image
                        </LegacyButton>
                      </>
                      )}
                  </div>
                  {thumbnailContent}
                </div>
              </div>
              )}
            </div>
            <div className={rootMainVideoClass}>
              <div className="main-video-container">
                <video
                  key={customThumbnailUrl || 'video-thumbnail-preview'}
                  controls
                  muted
                  poster={customThumbnailUrl || undefined}
                  ref={(videoEl) => {
                    this.displayVideoElement = videoEl;
                  }}
                  src={this.props.src}
                  crossOrigin="true"
                  onLoadedData={this.initVideoData.bind(this)}
                  onSeeked={() => {
                    if (isSeeking) {
                      this.setState({ isSeeking: false });
                    }
                  }}
                />
                {isSeeking && <Loading />}
              </div>
            </div>
          </div>
          <div className="video-thumbnail-modal__footer">
            <LegacyButton
              size="large"
              variant="hollow-reverse"
              onClick={() => this.closeClick(this)}
            >
              Close
            </LegacyButton>
            <LegacyButton
              data-testid="primary"
              size="large"
              variant="accent"
              className="loading"
              onClick={() => this.submit()}
              disabled={(hasError && errorType === 'error') || isLoading || isThumbnailUploading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </LegacyButton>
          </div>
        </div>
      </div>
    );
  }
}

VideoThumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  saveClicked: PropTypes.func.isRequired,
  services: PropTypes.arrayOf(PropTypes.string),
  frameInMiliseconds: PropTypes.number,
  rotationFix: PropTypes.number,
  title: PropTypes.string,
  category: PropTypes.string,
  youtubePrivacyStatus: PropTypes.string,
  membersToNotify: PropTypes.arrayOf(PropTypes.string),
  videoSize: PropTypes.number,
  uploadThumbnail: PropTypes.func,
  updateThumbnailById: PropTypes.func,
  originalMediaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showToastNotification: PropTypes.func,
  isOriginalTab: PropTypes.bool.isRequired,
  postType: PropTypes.string,
};

const VideoThumbnailWithComposeContext = ({
  category = 'None',
  youtubePrivacyStatus = YT_PRIVACY_PUBLIC,
  services = [],
  membersToNotify = [],
  frameInMiliseconds = 0,
  originalMediaId = undefined,
  postType = 'post',
  ...props
}) => {
  const { uploadThumbnail, updateThumbnailById } = useUploadsContext();
  const { showToastNotification } = useToastNotificationContext();

  return (
    <VideoThumbnail
      src={props.src}
      closeModal={props.closeModal}
      saveClicked={props.saveClicked}
      services={services}
      frameInMiliseconds={frameInMiliseconds}
      rotationFix={props.rotationFix}
      title={props.title}
      category={category}
      youtubePrivacyStatus={youtubePrivacyStatus}
      membersToNotify={membersToNotify}
      videoSize={props.videoSize}
      isOriginalTab={props.isOriginalTab}
      originalMediaId={originalMediaId}
      uploadThumbnail={uploadThumbnail}
      updateThumbnailById={updateThumbnailById}
      showToastNotification={showToastNotification}
      postType={postType}
      t={props.t}
    />
  );
};

VideoThumbnailWithComposeContext.propTypes = {
  ...VideoThumbnail.propTypes,
};

export default VideoThumbnailWithComposeContext;
